/**
 * Запуск яндекс карты в контейнере class="yamaps". Данные по карте беруться из json внутри.
 */
function mapInit() {
  document.querySelectorAll('.js-yandex-map').forEach((selector) => {
    const jsonElem = selector.querySelector('.js-yandex-map-json');
    if (!jsonElem) return;
    const mapData = JSON.parse(jsonElem.content.textContent);

    const myMap = new window.ymaps.Map(selector, {
      center: mapData.map.center,
      controls: ['zoomControl'],
      zoom: mapData.map.zoom,
      behaviors: ['drag'],
    }, {
      yandexMapDisablePoiInteractivity: true,
      suppressMapOpenBlock: true,
    });

    mapData.placemarks.forEach((placemark) => {
      myMap.geoObjects.add(new window.ymaps.Placemark(...placemark));
    });

    if (window.innerWidth < 1000) {
      myMap.behaviors.disable(['rightMouseButtonMagnifier', 'scrollZoom', 'drag']);
    }
  });
}

export default function yandexMap() {
  window.mapsInit = mapInit;
  const selector = document.querySelector('.js-yandex-map');
  if (!selector) return;
  const elem = document.createElement('script');
  elem.src = 'https://api-maps.yandex.ru/2.1/?load=package.map&lang=ru-RU&onload=mapsInit';
  document.getElementsByTagName('body')[0].appendChild(elem);
}
